export enum AlertBlockTypeEnum {
    TITLE = 'title',
    TEXT = 'text',
    IMAGE = 'image',
    DATE = 'date',
    ALERT_MENTIONS = 'alert_mentions',
    SURGE_ALERT = 'surge_alert',
    AUTOMATIC_MENTION_LIST = 'automatic',
    ANALYSIS = 'analysis',
    DIVIDER = 'divider',
    ONE_COLUMN_LAYOUT = 'one_column_layout',
    TWO_COLUMN_LAYOUT = 'two_column_layout',
    THREE_COLUMN_LAYOUT = 'three_column_layout',
    COVERAGE_CURATOR = 'coverage_curator',
    CHART = 'chart'
}
